"use client";

import React, { createContext, useState, ReactNode } from "react";
import { Products } from "@/common/entities/product/Product";

interface CompareContextProps {
    selectedProducts: Products[];
    toggleProduct: (product: Products) => void;
    isSelected: (productId: number) => boolean;
}

const CompareContext = createContext<CompareContextProps | undefined>(undefined);

export const CompareProvider = ({ children }: { children: ReactNode }) => {
    const [selectedProducts, setSelectedProducts] = useState<Products[]>([]);

    const toggleProduct = (product: Products) => {
        setSelectedProducts((prev) => {
            const exists = prev.find(p => p.id === product.id);
            if (exists) {
                return prev.filter(p => p.id !== product.id);
            } else if (prev.length < 4) {
                return [...prev, product];
            } else {
                return prev;
            }
        });
    };

    const isSelected = (productId: number) => selectedProducts.some(p => p.id === productId);

    return (
        <CompareContext.Provider value={{ selectedProducts, toggleProduct, isSelected }}>
            {children}
        </CompareContext.Provider>
    );
};

